import React, { useState } from "react";
import "../styles/DataView.css";

// Datos de ejemplo
const initialTables = [
  {
    name: "t_ocesa_eventos",
    description: "Tabla que contiene los eventos, fechas y tipo del evento.",
    fields: 3,
    lastUpdate: "2025-05-20",
  },
  {
    name: "t_ocesa_cobertura_mediatica",
    description: "Tabla que contiene la cobertura mediatica.",
    fields: 25,
    lastUpdate: "2025-05-22",
  },
  {
    name: "t_ocesa_survey",
    description: "Tabla que contiene la información de las encuestas por evento.",
    fields: 321,
    lastUpdate: "2025-05-15",
  },
];

const DataView = () => {
  const [search, setSearch] = useState("");
  const [tables, setTables] = useState(initialTables);

  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState({
    name: "",
    description: "",
    fields: "",
    lastUpdate: "",
  });

  const openModal = () => {
    setForm({
      name: "",
      description: "",
      fields: "",
      lastUpdate: new Date().toISOString().slice(0, 10),
    });
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);

  const saveTable = (e) => {
    e.preventDefault();
    setTables([
      ...tables,
      {
        ...form,
        fields: Number(form.fields),
        lastUpdate: form.lastUpdate || new Date().toISOString().slice(0, 10),
      },
    ]);
    setModalOpen(false);
  };

  const filteredTables = tables.filter(
    (table) =>
      table.name.toLowerCase().includes(search.toLowerCase()) ||
      table.description.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="data-view">
      {/* Header */}
      <div className="data-header">
        <div className="data-header-left">
          <h2 className="data-title">Datasets / Tablas</h2>
          <p className="data-subtitle">
            Catálogo de tablas disponibles para análisis.
          </p>
        </div>

        <div className="data-header-actions">
          <input
            className="data-search"
            type="text"
            placeholder="Buscar campo, tabla o dataset..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button className="data-new-btn" onClick={openModal}>
            + Nueva tabla
          </button>
        </div>
      </div>

      {/* Table wrapper */}
      <div className="table-card">
        <table className="data-table">
          <thead>
            <tr>
              <th>Dataset / Tabla</th>
              <th>Descripción breve</th>
              <th>Campos</th>
              <th>Última actualización</th>
            </tr>
          </thead>

          <tbody>
            {filteredTables.map((table) => (
              <tr key={table.name}>
                <td className="mono">{table.name}</td>
                <td>{table.description}</td>
                <td>{table.fields}</td>
                <td>{table.lastUpdate}</td>
              </tr>
            ))}

            {filteredTables.length === 0 && (
              <tr>
                <td colSpan={4} className="empty-row">
                  No hay tablas que coincidan con la búsqueda.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      {modalOpen && (
        <div className="modal-backdrop" onClick={closeModal}>
          <div
            className="modal-card"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="modal-title">Nueva tabla</h3>

            <form className="modal-form" onSubmit={saveTable}>
              <label className="field">
                <span>Nombre</span>
                <input
                  required
                  value={form.name}
                  onChange={(e) =>
                    setForm({ ...form, name: e.target.value })
                  }
                />
              </label>

              <label className="field">
                <span>Descripción</span>
                <input
                  required
                  value={form.description}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      description: e.target.value,
                    })
                  }
                />
              </label>

              <label className="field">
                <span># Campos</span>
                <input
                  type="number"
                  required
                  min={1}
                  value={form.fields}
                  onChange={(e) =>
                    setForm({ ...form, fields: e.target.value })
                  }
                />
              </label>

              <label className="field">
                <span>Fecha de actualización</span>
                <input
                  type="date"
                  value={form.lastUpdate}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      lastUpdate: e.target.value,
                    })
                  }
                />
              </label>

              <div className="modal-actions">
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={closeModal}
                >
                  Cancelar
                </button>
                <button type="submit" className="btn-save">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default DataView;
